import { Injectable, signal } from '@angular/core';
import { VideoResponseDto } from '../../../../common/general-types/videos.dto';

@Injectable({
  providedIn: 'root'
})
export class ViewSubManageService {

  approvingContent = signal<boolean>(false);
  whichContent = signal<string | undefined>(undefined);
  approvedVideos = signal<VideoResponseDto[]>([]);
  requiredVideos = signal<number>(0);
}
